"use strict";
import { gsap } from "gsap";

export default function faqAccordionGsap() {
    document.addEventListener("DOMContentLoaded", () => {
        const root = document.querySelector(".o-convenios-faq");
        if (!root) return;

        const items = Array.from(root.querySelectorAll("details.c-faq"));
        if (!items.length) return;

        const getAnswer = (details) => details.querySelector(".c-faq__answer");
        const getSummary = (details) =>
            details.querySelector("summary.c-faq__question");

        // Config
        const DURATION = 0.35;
        const EASE = "power2.out";
        const ACCORDION_MODE = true; // true = abre 1 e fecha os outros

        // Estado inicial
        items.forEach((details) => {
            const answer = getAnswer(details);
            if (!answer) return;

            gsap.set(answer, { overflow: "hidden" });

            if (details.open) {
                // aberto: deixa auto para responsivo
                gsap.set(answer, { height: "auto", opacity: 1, y: 0 });
            } else {
                gsap.set(answer, { height: 0, opacity: 0, y: -4 });
            }
        });

        const closeItem = (details) => {
            const answer = getAnswer(details);
            if (!answer) return;

            // mata animações anteriores
            gsap.killTweensOf(answer);

            // se já está fechado, sai
            if (!details.open) return;

            // fixa altura atual antes de animar
            gsap.set(answer, { height: answer.scrollHeight });

            gsap.to(answer, {
                height: 0,
                opacity: 0,
                y: -4,
                duration: DURATION,
                ease: EASE,
                onComplete: () => {
                    details.open = false;
                },
            });
        };

        const openItem = (details) => {
            const answer = getAnswer(details);
            if (!answer) return;

            gsap.killTweensOf(answer);

            // abre o details ANTES pra scrollHeight refletir o conteúdo (principalmente se vier fechado)
            details.open = true;

            // começa de 0
            gsap.set(answer, { height: 0, opacity: 0, y: -4 });

            const targetHeight = answer.scrollHeight;

            gsap.to(answer, {
                height: targetHeight,
                opacity: 1,
                y: 0,
                duration: DURATION,
                ease: EASE,
                onComplete: () => {
                    // depois de abrir, deixa height auto (evita quebrar em resize)
                    gsap.set(answer, { height: "auto" });
                },
            });
        };

        items.forEach((details) => {
            const summary = getSummary(details);
            if (!summary) return;

            summary.addEventListener("click", (e) => {
                e.preventDefault();

                const isOpen = details.open;

                if (ACCORDION_MODE) {
                    items.forEach((other) => {
                        if (other !== details) closeItem(other);
                    });
                }

                if (isOpen) closeItem(details);
                else openItem(details);
            });

            // acessibilidade: Enter / Space no summary
            summary.addEventListener("keydown", (e) => {
                const key = e.key;
                if (key !== "Enter" && key !== " ") return;
                e.preventDefault();
                summary.click();
            });
        });

        // Se o layout mudar (resize), mantém aberto com height auto
        window.addEventListener("resize", () => {
            items.forEach((details) => {
                if (!details.open) return;
                const answer = getAnswer(details);
                if (!answer) return;
                gsap.set(answer, { height: "auto" });
            });
        });
    });
}
